/**
 * This is "app in app", reduced version of main Vue app (frontend/vue-app/index.js).
 * It is used for initializing HTML of cards rendered with PHP.
 */
import Vue from 'vue'
import Vuex from 'vuex'

import * as components from './components/index'
import initSwiper from '../lib/init-swiper'
import initLazyImage from '../lib/lazy-image'
// import windowSizeMixin from './mixins/window-size'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    animate: true,
  },
})

const initCardsVueApp = (el, options = {}) => {
  const { mounted } = options

  new Vue({
    el,
    store,
    components,
    // mixins: [windowSizeMixin],
    mounted() {
      initLazyImage(this.$el)
      initSwiper(this.$el)
      if (mounted) {
        mounted()
      }
    },
  })
}

export default initCardsVueApp
